import { Component, OnInit, Inject, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Release } from '../../home/release';

import { NewReleaseService } from '../../new-release/new-release.service';
import { HomeService } from '../../home/home.service';
import { MainService } from '../../main.service';

import { Message, MenuItem } from 'primeng/primeng';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '../../../environments/environment';

// const URL = environment.uploadURL;
const URL = "/upload"

@Component({
  selector: 'app-release-edit-model',
  templateUrl: './release-edit-model.component.html',
  styleUrls: ['../../../style.scss', './release-edit-model.component.css']
})
export class ReleaseEditModelComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ReleaseEditModelComponent>,
    private fb: FormBuilder,
    private newReleaseService: NewReleaseService,
    private homeService: HomeService,
    private mainService: MainService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }


  releaseUpdateForm: FormGroup;
  fromDate: Date = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
  toDate: Date = new Date();
  formatFromDate;
  formatToDate;
  fdMonth;
  toMonth;
  options: {};
  userOptions: {};
  versionOptions: {};
  componentOptions: {};
  projectOptions: {}
  downloadOptions: {};
  editOptions: {};
  editEmailOptions: {};
  activityOptions: {};
  componentEditOptions: {};
  releaseEditDataOptions: {};
  changeWorkFlowOptions: {};
  discardOptions: {};
  releasecompOptions: {};
  updateBundleOptions: {};
  projectData;
  editRelease: any;
  editReleaseNote: any;
  editTestCase: any;

  editReleaseLoc: any;
  editReleaseNoteLoc: any;
  editTestCaseLoc: any;

  selectedProject: any;
  selectedComponents: any;
  selectedRelease: any;
  projectList: any[];

  responce: any;
  activityResponce: any;

  selectedProjectLatest: any;
  projectListLatest: any[];

  selectedWorkflowLatest: any;
  selectedWorkflow: any;

  selectedComponent: any;
  componentList: any[];
  editComponentList: any[];
  versionList: any[];
  userList: any[];

  status: any;
  workFlowList: any;

  selectedComponentLatest: any;
  selectedProjects: any;
  componentListLatest: any[];


  selectedEditReleaseOwner: any;
  selectedEditVersion: any;
  selectedEditWorkFlow: any;
  selectedEditComponent: any;
  selectedEditProject: any;
  selectedEditDescription: any;
  selectedEditComment: any;
  selectedEditQA: any;
  release_ID: any;
  cc_list: String;

  fileName: string;
  fileName_Note: string;
  fileName_Test: string;
  originalFileName: string;
  originalFileName_Note: string;
  originalFileName_Test: string;
  isUploaded: boolean = false;
  isSaved: boolean = false;
  isFileSelected: boolean = false;
  isNoteSelected: boolean = false;
  isTestCaseSelected: boolean = false;
  isComment: boolean = false;
  isMessage: boolean = false;
  fileMissing: boolean = false;

  projectName: string;
  componentName: string;
  wid: number;
  workflowMessage: string;
  sendCmt: string;

  _rid: any;
  _workflow: any;

  msgs: Message[];
  activeIndex: number;
  items: MenuItem[];
  display: boolean;
  releaseName: string;
  isUpload: boolean;
  savedIndex: Number;
  emailDesc: String;
  emailSubject: String;
  clickedOnce: boolean;
  binaryDIR: String;
  noteDIR: String;
  testCaseyDIR: String;
  fileStatus: any[] = [];

  // workflows to display in 'change state' button
  workflows = ['Dev', 'QA', 'UAT', 'Prod'];

  date = new Date();
  userEmail = localStorage.getItem('userEmail');
  userName = localStorage.getItem('userName');
  is_Admin = localStorage.getItem('is_Admin');


  // show edit model
  showEditModel(release: Release) {

    this.isUpload = release.is_Upload ? release.is_Upload : false;
    console.log("isUpload", this.isUpload);
    var r: Release = release;
    console.log("r", r);
    this.selectedEditDescription = r.description;
    this.releaseName = r.version;
    this.editRelease = r.file_name ? r.file_name : null;
    this.editReleaseNote = r.release_note ? r.release_note : null;
    this.editTestCase = r.test_cases ? r.test_cases : null;

    this.editReleaseLoc = r.storage_location ? r.storage_location : null;
    this.editReleaseNoteLoc = r.release_note_location ? r.release_note_location : null;
    this.editTestCaseLoc = r.test_case_location ? r.test_case_location : null;

    this.componentName = r.component;
    this.projectName = r.pkey;
    this.wid = 0;
    this.cc_list = r.cc_list;

    if (this.cc_list == '' || this.cc_list == null) {
      this.cc_list = r.owner.email;
      console.log("this.cc_list", this.cc_list);
    }

    this.release_ID = r.id;

    this.wid = r.workflow_id;
    this.activeIndex = r.workflow_id - 1;

    if (r.owner == this.userName || r.uploaded_by == this.userName || r.qa == this.userName || this.is_Admin == '1') {
      this.display = true;
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'warn', summary: 'Edit Release', detail: 'No Permission' });
    }

    // edit modal values
    setTimeout(() => {
      if (this.projectList != undefined) {
        for (var i = 0; i < this.projectList.length; i++) {
          if (this.projectList[i].name == r.project) {
            this.releaseUpdateForm.patchValue({
              project: this.projectList[i]
            }
            );
          }
        }
      }
    },
      2000);


    setTimeout(() => {
      if (this.workFlowList != undefined) {
        for (var i = 0; i < this.workFlowList.length; i++) {
          if (this.workFlowList[i].workflow == r.workflow) {
            this.releaseUpdateForm.patchValue({
              workflow: this.workFlowList[i]
            }
            );

            this.activeIndex = this.workFlowList[i].id - 1;

          } else {
            this.releaseUpdateForm.patchValue({
              workflow: { id: 1, workflow: "Dev" }
            }
            );

            this.activeIndex = 0;
          }
        }
      }
    },
      2000);


    this.releaseUpdateForm.get('allVersions').valueChanges.subscribe(isAll => {
      if (isAll != undefined) {

        if (isAll) {

          // loading version when all option selected
          this.versionOptions = {
            id: r.project_id,
            component: '',
            editMode: ''
          }

          this.getEditVersion(r);


        } else {

          this.versionOptions = {
            id: r.project_id,
            component: r.component,
            editMode: ''
          }
          // loading version when all option selected
          this.getEditVersion(r);

        }
      }

    })

    // patch email list to edit model

    var emailList = [];
    if (r.cc_list != null) {
      var emails = r.cc_list.split(",");

      for (let email of emails) {
        emailList.push(email);
      }

    }


    this.releaseUpdateForm.patchValue({
      emailList: emailList
    }
    );

    this.componentEditOptions = {
      id: r.project_id,
      list: ''
    };

    this.getEditComponents(r);

    this.userOptions = {
      id: r.project_id,
      role: ''
    };


    this.getEditUsers(r);

    if (this.isUpload) {
      this.versionOptions = {
        id: r.project_id,
        component: r.component,
        editMode: ''
      };

      this.getEditVersion(r);
    } else {
      this.versionOptions = {
        id: r.project_id,
        component: r.component,
        editMode: 'true'
      };

      this.getEditVersion(r);
    }

  }

  getEditComponents(release) {

    this.mainService.getComponents(this.componentEditOptions).then(components => {
      this.editComponentList = components;

      for (var i = 0; i < this.editComponentList.length; i++) {
        if (this.editComponentList[i].component == release.component) {
          this.releaseUpdateForm.patchValue({
            component: this.editComponentList[i]
          }
          );
        }

      }

    });

  }

  getEditUsers(release) {
    this.mainService.getUsers(this.userOptions).then(users => {
      this.userList = users;

      //qa 
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].name == release.qa) {
          this.releaseUpdateForm.patchValue({
            qa: this.userList[i]
          }
          );
        }
      }

      //owner
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].name == release.owner) {
          this.releaseUpdateForm.patchValue({
            owner: this.userList[i]
          }
          );
        }
      }

    });
  }

  getEditVersion(release) {

    this.mainService.getVersions(this.versionOptions).then(versions => {
      this.versionList = versions;

      for (var i = 0; i < this.versionList.length; i++) {
        if (this.versionList[i].version == release.version) {
          this.releaseUpdateForm.patchValue({
            version: this.versionList[i]
          }
          );
        }
      }
    });

    // check if edit version is empty then reload from all projects
    if (this.selectedEditVersion == undefined && !this.isUpload) {

      this.versionOptions = {
        id: release.project_id,
        component: '',
        editMode: 'true'
      };

      this.mainService.getVersions(this.versionOptions).then(versions => {
        this.versionList = versions;

        for (var i = 0; i < this.versionList.length; i++) {
          if (this.versionList[i].version == release.version) {
            this.releaseUpdateForm.patchValue({
              version: this.versionList[i]
            }
            );
          }
        }
      });

    }

  }







  update() {

    this.clickedOnce = true;
    if ((this.editRelease == null && this.isFileSelected == true)) {
      this.msgs = [];
      this.fileMissing = false;
      this.clickedOnce = false;
      this.msgs.push({ severity: 'warn', summary: 'Release File Not Uploaded', detail: '' });
    }
    else if (this.isFileSelected == true) {
      this.msgs = [];
      this.fileMissing = false;
      this.clickedOnce = false;
      this.msgs.push({ severity: 'error', summary: 'File Not Uploaded', detail: '' });
    }
    else if ((this.editRelease == null && this.fileName == undefined)) {
      this.msgs = [];
      this.fileMissing = false;
      this.clickedOnce = false;
      this.msgs.push({ severity: 'error', summary: 'Release is Missing', detail: '' });
    } else {
      console.log("this.releaseUpdateForm.valid", this.releaseUpdateForm.valid)

      if (this.releaseUpdateForm.valid) {

        var sendDesc = this.stripHTML(this.stripHTML(this.selectedEditDescription));

        this.componentName = this.selectedEditComponent.component;
        this.projectName = this.selectedEditProject.key;
        this.emailDesc = sendDesc;

        var ccList = '';

        if (this.releaseUpdateForm.get('emailList').value != '') {
          if (this.isUpload) {
            ccList = this.releaseUpdateForm.get('emailList').value + ',' + this.selectedEditReleaseOwner.email;
          } else {
            ccList = this.releaseUpdateForm.get('emailList').value
          }

        } else {
          ccList = this.selectedEditReleaseOwner.email;
        }

        // send release options

        this.options = {
          project: this.selectedEditProject.id,
          component: this.selectedEditComponent.id,
          version: this.selectedEditVersion.version,
          desc: sendDesc,
          fileName: this.editRelease ? this.editRelease : this.fileName,
          owner: this.selectedEditReleaseOwner.id,
          qa: this.selectedEditQA ? this.selectedEditQA.name : '',
          destination: this.editReleaseLoc ? this.editReleaseLoc : this.binaryDIR,
          // destination: this.editReleaseLoc ? this.editReleaseLoc : '../Uploads/Binary/' + this.projectName + '/' + this.componentName + '/' + this.fileName + '/' + this.originalFileName,
          note: this.editReleaseNote ? this.editReleaseNote : this.fileName_Note,
          relaseNote: this.editReleaseNoteLoc ? this.editReleaseNoteLoc : this.noteDIR,
          // relaseNote: this.editReleaseNoteLoc ? this.editReleaseNoteLoc : this.originalFileName_Note ? '../Uploads/Release_Notes/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Note + '/' + this.originalFileName_Note : '',
          test: this.editTestCase ? this.editTestCase : this.fileName_Test,
          testCases: this.editTestCaseLoc ? this.editTestCaseLoc : this.testCaseyDIR,
          // testCases: this.editTestCaseLoc ? this.editTestCaseLoc : this.originalFileName_Test ? '../Uploads/Test_Cases/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Test + '/' + this.originalFileName_Test : '',
          uploaded_by: this.userName,
          workflow: this.selectedEditWorkFlow.id,
          skipComment: '',
          // cc: this.releaseUpdateForm.get('emailList').value ? this.releaseUpdateForm.get('emailList').value : this.selectedEditReleaseOwner.email  ccList
          cc: ccList
          // worflow: '1', // Dev is default workflow ID - 1
        };

        this.editOptions = {
          release_id: this.release_ID,
          project: this.selectedEditProject.id,
          component: this.selectedEditComponent.id,
          version: this.selectedEditVersion.version,
          desc: sendDesc,
          fileName: this.editRelease ? this.editRelease : this.fileName,
          owner: this.selectedEditReleaseOwner.id,
          destination: this.editReleaseLoc ? this.editReleaseLoc : this.binaryDIR,
          // destination: this.editReleaseLoc ? this.editReleaseLoc : '../Uploads/Binary/' + this.projectName + '/' + this.componentName + '/' + this.fileName + '/' + this.originalFileName,
          note: this.editReleaseNote ? this.editReleaseNote : this.fileName_Note,
          relaseNote: this.editReleaseNoteLoc ? this.editReleaseNoteLoc : this.noteDIR,
          // relaseNote: this.editReleaseNoteLoc ? this.editReleaseNoteLoc : this.originalFileName_Note ? '../Uploads/Release_Notes/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Note + '/' + this.originalFileName_Note : '',
          test: this.editTestCase ? this.editTestCase : this.fileName_Test,
          testCases: this.editTestCaseLoc ? this.editTestCaseLoc : this.testCaseyDIR,
          // testCases: this.editTestCaseLoc ? this.editTestCaseLoc : this.originalFileName_Test ? '../Uploads/Test_Cases/' + this.projectName + '/' + this.componentName + '/' + this.fileName_Test + '/' + this.originalFileName_Test : '',
          updated_by: this.userName,
          workflow: this.selectedEditWorkFlow.id,
          qa: this.selectedEditQA ? this.selectedEditQA.name : '',
          // cc: this.releaseUpdateForm.get('emailList').value ? this.releaseUpdateForm.get('emailList').value : this.selectedEditReleaseOwner.email,
          cc: ccList,
        };


        this.emailSubject = '';
        if (this.isUpload) {
          this.emailSubject = this.selectedEditVersion.version;
        } else {
          this.emailSubject = "Updated - " + this.selectedEditVersion.version;
        }


        if (this.isComment) {
          var userCmt = this.selectedEditComment;

          this.sendCmt = (userCmt.replace("<p>", "")).replace("</p>", "");

          this.changeWorkFlowOptions = {
            release_id: this.release_ID,
            workflow: this.selectedEditWorkFlow.id,
            comment: this.sendCmt,
            user: this.userEmail
          }

          this.mainService.sendEditWorkFlow(this.changeWorkFlowOptions).then(workflow => {
            this.status = JSON.stringify(workflow.res);
            this.msgs = [];
            this.msgs.push({ severity: 'success', summary: 'Stage Updated' });
          });

        }

        this.activityOptions = {
          user: this.userEmail,
          action: "Edit",
          file: "--"
        };

        this.newReleaseService.sendActivity(this.activityOptions).then(res => {
          this.activityResponce = res;
        });

        if (this.isUpload) {
          this.sendNewReleaseData();
        } else {
          this.sendEditReleaseData();
        }


        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Saved' });



        this.uploader.queue = [];
      } else {
        this.validateAllFormFields(this.releaseUpdateForm);
        this.clickedOnce = false;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Form is not Complete', detail: 'Please Check the Entered Data' });
      }
    }
  }

  public uploader: FileUploader = new FileUploader({ url: URL });
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;


  public uploadData() {

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Uploaded', detail: item.file.name });
      if (response) {
        if (response.includes("Binary")) {
          this.binaryDIR = response;
        } else if (response.includes("Release_Notes")) {
          this.noteDIR = response;
        } else if (response.includes("Test_Cases")) {
          this.testCaseyDIR = response;
        } else {
          console.log("DIR Err");
          this.msgs.push({ severity: 'Error', summary: 'Upload Error' });
        }
      } else {
        this.msgs.push({ severity: 'Error', summary: 'Upload Error' });
      }
      this.isUploaded = true;
      this.isFileSelected = false;
      this.isNoteSelected = false;
    };

    this.uploader.onCompleteAll = () => {

      this.isUploaded = true;
      this.isFileSelected = false;
      this.isNoteSelected = false;
      setTimeout(() => {
        this.msgs = [];
        this.msgs.push({ severity: 'info', summary: 'Don\'t Forget to hit the \'Save\' Button !!' });
      },
        1500);

    };

    this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
      this.msgs = [];
      this.msgs.push({ severity: 'Error', summary: 'Upload Failed' });
    };
  }



  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  stripHTML(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText;
  }




  fileEvent(e: any) {

    // this.fileStatus = 'Binary';
    this.fileStatus.push('Binary');

    this.isFileSelected = true;
    let file = e.target.files[0];

    this.originalFileName = 'Binary_' + file.name;

    // Used substring to get only the file name
    this.fileName = file.name.substring(0, file.name.lastIndexOf('.'));
  }

  fileEventNote(e: any) {

    // this.fileStatus = 'Release_Notes';
    this.fileStatus.push('Release_Notes');

    this.isNoteSelected = true;

    let file = e.target.files[0];

    this.originalFileName_Note = 'ReleaseNotes_' + file.name;

    // Used substring to get only the file name
    this.fileName_Note = file.name.substring(0, file.name.lastIndexOf('.'));
  }

  fileEventTest(e: any) {


    // this.fileStatus = 'Test_Cases';
    this.fileStatus.push('Test_Cases');

    this.isTestCaseSelected = true;

    let file = e.target.files[0];

    this.originalFileName_Test = 'TestCases_' + file.name;

    // Used substring to get only the file name
    this.fileName_Test = file.name.substring(0, file.name.lastIndexOf('.'));

  }


  sendEditReleaseData() {

    this.homeService.sendEditData(this.editOptions).then(res => {
      this.responce = res;

      if (this.responce.status == 'sent') {
        this.isSaved = true;

        this.sendEditEmail();

        setTimeout(() => {
          this.onNoClick();
        },
          200);
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'Error', summary: this.responce });
      }

    });
  }

  sendNewReleaseData() {
    this.newReleaseService.sendRelease(this.options).then(res => {
      this.responce = res;

      if (this.responce.status == 'sent') {
        this.isSaved = true;

        this.savedIndex = this.responce.index;

        this.sendEditEmail();

        this.updateBundleOptions = {
          rbd_id: this.data.rbd_id,
          version: this.selectedEditVersion.version,
          rid: this.responce.index,
          component: this.selectedEditComponent.id
        }

        this.updateBundle();



        setTimeout(() => {
          this.onNoClick();
        },
          200);
      } else {
        this.msgs = [];
        this.clickedOnce = false;
        this.msgs.push({ severity: 'Error', summary: this.responce });
      }

    });
  }

  sendEditEmail() {

    var ccList = '';
    if (this.releaseUpdateForm.get('emailList').value != '') {
      if (this.isUpload) {
        ccList = this.releaseUpdateForm.get('emailList').value + ',' + this.selectedEditReleaseOwner.email;
      } else {
        ccList = this.releaseUpdateForm.get('emailList').value
      }

    } else {
      ccList = this.selectedEditReleaseOwner.email;
    }

    this.editEmailOptions = {
      fromEmail: this.userEmail,
      fromUser: this.userName,
      toEmail: this.selectedEditQA ? this.selectedEditQA.email : this.selectedEditReleaseOwner.email,
      toUser: this.selectedEditQA ? this.selectedEditQA.name : this.selectedEditReleaseOwner.name,
      subject: this.emailSubject,
      version: this.selectedEditVersion.version,
      project: this.selectedEditProject.name,
      // cc: this.releaseUpdateForm.get('emailList').value ? this.releaseUpdateForm.get('emailList').value : this.selectedEditReleaseOwner.email,
      cc: ccList,
      component: this.selectedEditComponent.component,
      desc: this.emailDesc,
      index: this.release_ID ? this.release_ID : this.savedIndex
    };

    this.newReleaseService.sendReleaseEmail(this.editEmailOptions).then(res => {
      this.activityResponce = res;
    });
  }


  updateBundle() {
    this.mainService.UpdateBundleVersionData(this.updateBundleOptions).then(res => {
      this.activityResponce = res;
    });

  }

  getWorkflow() {
    this.mainService.getWorkflow(this.options).then(workflow => {
      this.workFlowList = workflow
      this.items = [];
      for (var i = 0; i < this.workFlowList.length; i++) {
        if (i != 0) {
          var obj = { label: this.workFlowList[i].workflow };
          this.items.push(obj);
        }
      }

    });


    this.releaseUpdateForm.get('workflow').valueChanges.subscribe(workflow => {
      if (workflow != undefined) {
        if (workflow.id - 1 > this.wid) {
          this.isComment = true;
        } else {
          this.isComment = false;
        }
      }
    })
  }

  getProjects() {
    var that = this;
    this.projectOptions = {
      user: this.userEmail
    };

    this.mainService.getProjectList(this.projectOptions).then(projects => {
      that.projectList = projects;
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  ngOnInit() {

    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      //form.append('version', '1.0.0.0');
      form.append('project', this.projectName);
      console.log(this.projectName);
      form.append('component', this.componentName);
      console.log(this.componentName);
      form.append('type', this.fileStatus[0]);
      console.log(this.fileStatus[0]);
      form.append('version', this.selectedEditVersion.version);
      console.log(this.selectedEditVersion.version);
      this.fileStatus.shift();
    };


    this.releaseUpdateForm = this.fb.group({
      project: [{ value: '', disabled: true }, Validators.required],
      component: [{ value: '', disabled: true }, Validators.required],
      owner: ['', Validators.required],
      version: ['', Validators.required],
      description: ['', Validators.required],
      workflow: ['', Validators.required],
      comment: ['', Validators.compose([Validators.minLength(20), Validators.maxLength(100)])],
      qa: [''],
      emailList: [''],
      allVersions: [false]
    });

    // console.log(this.data);

    this.getProjects();

    this.getWorkflow();

    setTimeout(() => {
      this.showEditModel(this.data);
    },
      1000);
  }

}
